/**
 * Converts a function to a string representation that includes its invocation with the given argument names.
 *
 * @param {Function} f - The function to convert.
 * @param {string} [argumentNames] - Optional comma-separated argument names to include in the call expression.
 * @returns {string} A string representation of the function wrapped in a return statement with arguments.
 */
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function functionBodyToString(f, argumentNames) {
    return `return (${f.toString()})(${argumentNames})`;
}
